var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletedJobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1808_3502)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FFFBF4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1808_3502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2 10.4771L16.7385 6.17689C16.5124 6.06086 16.2583 6 16 6C15.7417 6 15.4876 6.06086 15.2615 6.17689L6.8 10.4789C6.55835 10.6017 6.35664 10.7825 6.21592 11.0025C6.07519 11.2224 6.00063 11.4734 6 11.7292V20.2708C6.00063 20.5266 6.07519 20.7776 6.21592 20.9975C6.35664 21.2175 6.55835 21.3983 6.8 21.5211L15.2615 25.8231C15.4876 25.9391 15.7417 26 16 26C16.2583 26 16.5124 25.9391 16.7385 25.8231L25.2 21.5211C25.4416 21.3983 25.6434 21.2175 25.7841 20.9975C25.9248 20.7776 25.9994 20.5266 26 20.2708V11.7301C25.9999 11.4738 25.9256 11.2223 25.7848 11.0018C25.6441 10.7814 25.4421 10.6001 25.2 10.4771ZM16 7.42722L23.726 11.3568L20.8625 12.8117L13.1365 8.88206L16 7.42722ZM16 15.2864L8.27404 11.3568L11.5346 9.69835L19.2606 13.6279L16 15.2864ZM24.4615 20.2743L16.7692 24.1852V16.5216L19.8462 14.9578V18.1443C19.8462 18.3338 19.9272 18.5155 20.0715 18.6495C20.2157 18.7835 20.4114 18.8588 20.6154 18.8588C20.8194 18.8588 21.0151 18.7835 21.1593 18.6495C21.3036 18.5155 21.3846 18.3338 21.3846 18.1443V14.1754L24.4615 12.6116V20.2708V20.2743Z",
    fill: "#FDAF22"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1808_3502",
    x: -10,
    y: -2,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.686275 0 0 0 0 0.133333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1808_3502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1808_3502",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1808_3502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedJobs);
export default __webpack_public_path__ + "static/media/completed-jobs.02d865454ab85f1ad10b19d7d3d4d22f.svg";
export { ForwardRef as ReactComponent };